import React from "react";
import { Link } from "react-router-dom";
import {
    UPDATE_LOOKING_FOR, ABOUT_ME_SENTENCE,
    UPDATE_BIRTHDATE, UPDATE_PERSONAL_STATUS, UPDATE_NICKNAME,
    UPDATE_MEMBER_LOCATION,
    UPDATE_HEIGHT
} from '../../../navigation/Constants';
import { TagProps } from './../../../typings/tag';

export interface FirstSectionQuestionsProps {
    lookingFor: string[];
    aboutMeSentence: string | null;
    birthDate: string | null;
    personalStatusName: string | null;
    memberNickName: string | null;
    locationName: string | undefined;
    height: string | undefined;

}

const FirstSectionQuestions = ({
    memberNickName, lookingFor, aboutMeSentence, locationName,
    birthDate, personalStatusName, height }: FirstSectionQuestionsProps) => {

    return (
        <ul className="edit_info_list w-list-unstyled">
            <li className="edit_info_item">
                <Link className="edit_info_link w-inline-block" to={UPDATE_NICKNAME}>
                    <div className="edit_link_info w-clearfix">
                        <h4 className="edit_link_title">כינוי</h4>
                        <div>{memberNickName}</div>
                        <div className="edit_ar_block w-clearfix">
                            <img
                                src="/assets/images/prior_arrow.svg"
                                loading="lazy"
                                alt=""
                                className="edit_arrow"
                            />
                        </div>
                    </div>
                </Link>
            </li>
            <li className="edit_info_item">
                <Link className="edit_info_link w-inline-block" to={UPDATE_BIRTHDATE}>
                    <div className="edit_link_info w-clearfix">
                        <h4 className="edit_link_title">תאריך לידה</h4>
                        <div>{birthDate}</div>
                        <div className="edit_ar_block w-clearfix">
                            <img
                                src="/assets/images/prior_arrow.svg"
                                loading="lazy"
                                alt=""
                                className="edit_arrow"
                            />
                        </div>
                    </div>
                </Link>
            </li>
            <li className="edit_info_item">
                <Link className="edit_info_link w-inline-block" to={UPDATE_MEMBER_LOCATION}>
                    <div className="edit_link_info w-clearfix">
                        <h4 className="edit_link_title">עיר</h4>
                        <div>{locationName}</div>
                        <div className="edit_ar_block w-clearfix">
                            <img
                                src="/assets/images/prior_arrow.svg"
                                loading="lazy"
                                alt=""
                                className="edit_arrow"
                            />
                        </div>
                    </div>
                </Link>
            </li>
            <li className="edit_info_item">
                <Link className="edit_info_link w-inline-block" to={UPDATE_HEIGHT}>
                    <div className="edit_link_info w-clearfix">
                        <h4 className="edit_link_title">גובה</h4>
                        <div>{(parseInt(height!) === 0) ? "לא נבחר" : height + ' ס"מ'}</div>
                        <div className="edit_ar_block w-clearfix">
                            <img
                                src="/assets/images/prior_arrow.svg"
                                loading="lazy"
                                alt=""
                                className="edit_arrow"
                            />
                        </div>
                    </div>
                </Link>
            </li>
            <li className="edit_info_item">
                <Link className="edit_info_link w-inline-block" to={UPDATE_LOOKING_FOR}>
                    <div className="edit_link_info w-clearfix">
                        <h4 className="edit_link_title">רוצה להכיר כאן</h4>
                        <div>{lookingFor.join(", ")}</div>
                        <div className="edit_ar_block w-clearfix">
                            <img
                                src="/assets/images/prior_arrow.svg"
                                loading="lazy"
                                alt=""
                                className="edit_arrow"
                            />
                        </div>
                    </div>
                </Link>
            </li>

            <li className="edit_info_item">
                <Link className="edit_info_link w-inline-block" to={UPDATE_PERSONAL_STATUS}>
                    <div className="edit_link_info w-clearfix">
                        <h4 className="edit_link_title">סטטוס משפחתי</h4>
                        <div>{personalStatusName}</div>
                        <div className="edit_ar_block w-clearfix">
                            <img
                                src="/assets/images/prior_arrow.svg"
                                loading="lazy"
                                alt=""
                                className="edit_arrow"
                            />
                        </div>
                    </div>
                </Link>
            </li>
            <li className="edit_info_item">
                <Link className="edit_info_link w-inline-block" to={{ pathname: ABOUT_ME_SENTENCE, state: { value: aboutMeSentence } }}>
                    <div className="edit_link_info w-clearfix">
                        <h4 className="edit_link_title">קצת עליי</h4>
                        {aboutMeSentence && <div>{aboutMeSentence?.length > 35 ? `${aboutMeSentence?.slice(0, 35)}...` : `${aboutMeSentence}`}</div>}
                        <div className="edit_ar_block w-clearfix">
                            <img
                                src="/assets/images/prior_arrow.svg"
                                loading="lazy"
                                alt=""
                                className="edit_arrow"
                            />
                        </div>
                    </div>
                </Link>
            </li>
        </ul>
    )

}

export default FirstSectionQuestions;